export default {
    setMajor(state, payload) {
        state.majors = payload;
    },
    addMajor(state, major) {
        state.majors.push(major);
    },
};